import "./styles.sass";
import classNames from "classnames";

export type LoyaltyCircleProgressVariant = "colored" | "bordered";

export type LoyaltyCircleProgressProps = {
  variant?: LoyaltyCircleProgressVariant;
  className?: string;
};

const LoyaltyCircleProgress = ({
  variant,
  className,
}: LoyaltyCircleProgressProps) => {
  const classNameCircle = classNames(
    "LoyaltyCircleProgress",
    variant && `LoyaltyCircleProgress_${variant}`,
    className,
  );

  return <div className={classNameCircle} />;
};

export default LoyaltyCircleProgress;
